import { render, staticRenderFns } from "./hcmIndex.vue?vue&type=template&id=949bac32"
import script from "./hcmIndex.vue?vue&type=script&lang=js"
export * from "./hcmIndex.vue?vue&type=script&lang=js"
import style0 from "./hcmIndex.vue?vue&type=style&index=0&id=949bac32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports